export function examQuizStateReducer(
  state = { loading: true, error: false, questions: [] },
  action
) {
  switch (action.type) {
    case "GET_PAPER":
      return {
        ...state,
        paper: action.payload
      };
    case "GET_PAPER_QUESTIONS":
      return {
        ...state,
        questions: action.payload,
        loading: false
      };
    case "START_EXAM":
      return {
        ...state,
        examState: "started"
      };
    case "END_EXAM":
      return {
        ...state,
        examState: "ended"
      };
    case "EXAM_TIME":
      return {
        ...state,
        examTime: action.payload
      };
    default:
      return state;
  }
}
